import validator from "validator";

export const passwordOptions: validator.strongPasswordOptions = {
	minLength: 8,
	minLowercase: 1,
	minUppercase: 1,
	minNumbers: 1,
	minSymbols: 0,
};
